"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPPORT_URL = exports.SUPPORT_PHONE = exports.SUPPORT_EMAIL = void 0;
// Contact
var SUPPORT_EMAIL = 'support@earnup.com';
exports.SUPPORT_EMAIL = SUPPORT_EMAIL;
var SUPPORT_PHONE = '1-800-209-9700';
exports.SUPPORT_PHONE = SUPPORT_PHONE;
var SUPPORT_URL = 'https://support.earnup.com';
exports.SUPPORT_URL = SUPPORT_URL;